"use client"
import React from "react";
import { Formik } from "formik";
import { Form, FormControl } from "react-bootstrap";
import ReCAPTCHAv3Button from "@/components/shared/RcCAPTCHAv3Button";
import PhoneInputWrapper from "@/components/shared/PhoneInputWrapper";

let yup = require("yup");
const postalCodes = require("postal-codes-js");

yup.addMethod(yup.string, "validPostalCode", function() {
  return this.test({
    name: "validPostalCode",
    message: "Please enter a valid postal code.",
    test: (postalCode = "") => {
      if (!postalCode || postalCode.trim() === "") {
        return true;
      }
      return postalCodes.validate("us", postalCode) === true;
    }
  });
});

const CommunitySubscriberForm = ({ configuration, onSubmit }) => {
  const generateSchema = fields => {
    const schemaFields = {};

    fields?.forEach(fieldObj => {
      let required = fieldObj.required;
      if (fieldObj.mapToField === "BO_EMAIL_ADDRESS") {
        schemaFields["emailAddress"] = required
          ? yup
              .string()
              .email()
              .required()
              .label("Email Address")
          : yup
              .string()
              .email()
              .label("Email Address");
      } else if (fieldObj.mapToField === "BO_FIRSTNAME") {
        schemaFields["firstName"] = required
          ? yup
              .string()
              .required()
              .label("First Name")
          : yup.string().label("First Name");
      } else if (fieldObj.mapToField === "BO_LASTNAME") {
        schemaFields["lastName"] = required
          ? yup
              .string()
              .required()
              .label("Last Name")
          : yup.string().label("Last Name");
      } else if (fieldObj.mapToField === "BO_POSTAL_CODE") {
        schemaFields["postalCode"] = required
          ? yup
              .string()
              .required()
              .validPostalCode()
              .label("Postal Code")
          : yup
              .string()
              .validPostalCode()
              .label("Postal Code");
      } else if (fieldObj.mapToField === "BO_ORGANIZATION") {
        schemaFields["organization"] = required
          ? yup
              .string()
              .required()
              .label("Business/Organization")
          : yup.string().label("Business/Organization");
      } else if (fieldObj.mapToField === "BO_PHONE_NUMBER") {
        schemaFields["phoneNumber"] = required
          ? yup
              .string()
              .required()
              .label("Phone Number")
          : yup.string().label("Phone Number");
      }
    });
    return yup.object().shape(schemaFields);
  };

  var subscriberSchema = generateSchema(
    configuration ? configuration.questions : []
  );

  const values = {
    firstName: "",
    lastName: "",
    emailAddress: "",
    postalCode: "",
    organization: "",
    phoneNumber: ""
  };

  const getFieldNames = schema => {
    const schemaDescription = schema.describe();
    // console.log("schemaDescription", schemaDescription, Object.keys(schemaDescription.fields));
    return Object.keys(schemaDescription.fields);
  };

  const getFieldSchemaObject = (schema, fieldName) => {
    const schemaDescription = schema.describe();
    return schemaDescription.fields[fieldName];
  };

  return (
    <Formik
      initialValues={values}
      validationSchema={subscriberSchema}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          onSubmit(values, () => {
            setSubmitting(false);
          });
        }, 400);
      }}
    >
      {({
        handleSubmit,
        handleChange,
        handleBlur,
        isSubmitting,
        isValid,
        values,
        touched,
        errors,
        submitForm,
        setFieldValue
      }) => (
        <Form className="no-style" onSubmit={handleSubmit}>
          <h3>{configuration.greeting}</h3>
          <p>{configuration.greetingText}</p>
          {getFieldNames(subscriberSchema).map(fieldName => {
            const fieldSchema = getFieldSchemaObject(
              subscriberSchema,
              fieldName
            );
            const required =
              fieldSchema.tests &&
              fieldSchema.tests.findIndex(test => test.name === "required") >
                -1;
            return (
              <div className="form-group" key={fieldName} id={`validationFormik${fieldName}`}>
                <Form.Label
                  bsPrefix={`form-label ${required ? "required" : ""}`}
                >
                  {fieldSchema.label}
                </Form.Label>
                {fieldName === "phoneNumber" ? (
                  <PhoneInputWrapper
                    value={values.phoneNumber}
                    onChange={value => setFieldValue("phoneNumber", value)}
                  />
                ) : (
                  <FormControl
                    name={fieldName}
                    value={values[fieldName]}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isInvalid={!!errors[fieldName] && touched[fieldName]}
                    placeholder={fieldSchema.label}
                  />
                )}
                <Form.Control.Feedback type="invalid">
                  {errors[fieldName]}
                </Form.Control.Feedback>
              </div>
            );
          })}

          <ReCAPTCHAv3Button
            action={"subscribeToCommunity"}
            onVerify={success => {
              if (success) {
                submitForm();
              }
            }}
            style={{ width: "12rem", marginTop: "1.5rem" }}
            disabled={!isValid || isSubmitting}
          >
            Subscribe
          </ReCAPTCHAv3Button>
        </Form>
      )}
    </Formik>
  );
};
export default CommunitySubscriberForm;
